import React from 'react'
import { Icon } from '../../../../components'
import './style.scss'

const Steps = () => {
    return (
        <section className="login-page__steps steps">
            <h2 className="steps__heading">Jak działa Generator Testów?</h2>
            <ul className="steps__list">
                <li className="steps__item">
                    <div className="steps__icon">
                        <Icon name="login" />
                    </div>
                    <h4 className="steps__title">Logowanie</h4>
                    <p className="steps__description">zaloguj się lub załóż konto Operon</p>
                </li>
                <li className="steps__item">
                    <div className="steps__icon">
                        <Icon name="new-test" />
                    </div>
                    <h4 className="steps__title">Nowy test</h4>
                    <p className="steps__description">kliknij utwórz nowy test, wybierz poziom nauczania i klasę</p>
                </li>
                <li className="steps__item">
                    <div className="steps__icon">
                        <Icon name="select-filter" />
                    </div>
                    <h4 className="steps__title">Przedmiot i temat</h4>
                    <p className="steps__description">wybierz przedmiot i temat zadania</p>
                </li>
                <li className="steps__item">
                    <div className="steps__icon">
                        <Icon name="add-tasks" />
                    </div>
                    <h4 className="steps__title">Test</h4>
                    <p className="steps__description">dodaj zadania do swojego testu</p>
                </li>
                <li className="steps__item">
                    <div className="steps__icon">
                        <Icon name="save-test" />
                    </div>
                    <h4 className="steps__title">Zapisz test</h4>
                    <p className="steps__description">zapisz i wydrukuj test</p>
                </li>
            </ul>
        </section>
    )
}

export default Steps
